import React from "react";
import { Link } from "react-router-dom";
import "./Apropos.css"; // un seul fichier CSS pour toutes les sections


// Premier set de services
const servicesMain = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1E40AF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4 21v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    ),
    title: "Création d’Entreprise",
    description:
      "Accompagnement complet pour créer votre société au Maroc : obtention du certificat négatif, rédaction des statuts, enregistrement de la société et publication de l’annonce légale.",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1E40AF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 6h18M3 12h18M3 18h18"></path>
      </svg>
    ),
    title: "Domiciliation",
    description:
      "Service complet de domiciliation juridique avec des adresses prestigieuses dans les grandes villes du Maroc (Casablanca, Rabat). Inclut : attestation de domiciliation, utilisation de l’adresse sur vos documents commerciaux, réception du courrier et alerte sur téléphone à l’arrivée de colis ou courrier, avec possibilité de réexpédition.",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1E40AF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="3 6 9 12 3 18"></polyline>
        <polyline points="9 6 15 12 9 18"></polyline>
        <polyline points="15 6 21 12 15 18"></polyline>
      </svg>
    ),
    title: "Travaux juridique",
    description:
      "Nos conseillers vous accompagnent dans tous les aspects du droit commercial, incluant : extension d’objet social, transfert de siège, augmentation de capital, cession de parts, nomination/démission de gérant, liquidation, modification des statuts, changement de forme juridique, rédaction de contrats et consultations juridiques.",
  },
];

// Deuxième set de services
const servicesExtra = [
  {
    title: "Communication",
    icon: "/image/image56.jpg",
    description:
      "Nous proposons une gamme complète de services numériques professionnels qui vous aident à construire et gérer votre présence en ligne de manière efficace et performante, incluant :",
    list: [
      "Systèmes de gestion de contenu pour créer et gérer votre site facilement.",
      "Boutiques virtuelles et e‑commerce pour étendre vos ventes et atteindre de nouveaux clients.",
      "Sites de présentation et catalogues en ligne pour mettre en valeur vos produits et services de manière attrayante et professionnelle.",
      "Systèmes de portails en ligne pour faciliter l’accès à vos services et offrir une expérience utilisateur fluide.",
      "Tout autre site dynamique répondant à vos besoins spécifiques et renforçant votre présence digitale.",
    ],
  },
  {
    title: "Services divers",
    icon: "/image/image66.jpg",
    description:
      "Nous proposons une gamme de services variés pour répondre à vos besoins, incluant le soutien administratif, les conseils juridiques et les services financiers, de manière professionnelle et adaptée à chaque entreprise.",
    list: [
      "Formation dans les métiers de la comptabilité",
      "Dépôt de marque",
      "Représentation fiscale des sociétés étrangères",
      "Etc ……",
    ],
  },
];

const ServicesPage = () => {
  return (
    <div>
      {/* HERO SECTION */}
      <section className="services-hero">
        <div className="services-overlay"></div>
        <div className="services-content">
          <h1>Nos Services</h1>
          <p>
            Nous accompagnons les entreprises avec des solutions professionnelles
            <br />
            adaptées à leurs besoins.
          </p>
        </div>
        <div className="services-wave">
          <svg viewBox="0 0 1440 200" preserveAspectRatio="none">
            <path
              d="M0,160 C360,80 1080,240 1440,120 L1440,200 L0,200 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </section>

      {/* MAIN SERVICES SECTION */}
      <section className="services-section">
        <h2 className="services-title">Nos Services</h2>
        <p className="services-subtitle">
          Nous proposons une gamme complète de services, conçus pour répondre aux besoins de tous types d’entreprises.
        </p>
        <div className="services-grid">
          {servicesMain.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-desc">{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ACCOUNTING SECTION */}
      <section className="accounting-section">
        <div className="accounting-container">
          <div className="accounting-left">
            <h2>Travaux de comptabilité</h2>
            <div className="underline"></div>
          </div>
          <div className="accounting-right">
            <p>
              Depuis janvier 2017, le Maroc a rendu obligatoires la <strong>télé-déclaration</strong> et le <strong>télépaiement</strong> pour toutes les entreprises. 
              Notre cabinet propose une <strong>gestion comptable en ligne</strong> : chaque client dispose d’un espace privé pour déposer ses pièces comptables scannées et communiquer avec son chargé de compte. 
              Les télé-déclarations validées par le client sont ensuite transmises par le cabinet à l’administration fiscale, et toute obligation de paiement est signalée par une alerte.
            </p>
            <p>
              Toutes les obligations comptables et fiscales sont prises en charge : <strong>TVA, bilans, comptes de résultat, Etat 9421, Déclaration TP, PV AGO</strong>. 
              Ce service sécurisé permet aux jeunes entreprises de <strong>se concentrer sur leur cœur de métier</strong> en laissant leur comptabilité entre les mains de professionnels expérimentés.
            </p>
          </div>
        </div>
      </section>

      {/* EXTRA SERVICES CARDS */}
<section className="features-area">

  <div className="features-grid">
    {servicesExtra.map((service, index) => (
      <div className="feature-box" key={index}>
        
        <img 
          src={service.icon} 
          alt={service.title} 
          className="feature-box-icon" 
        />
        
        <h3 className="feature-box-title">
          {service.title}
        </h3>

        <p className="feature-box-text">
          {service.description}
        </p>

        {service.list.length > 0 && (
          <ul className="feature-box-list">
            {service.list.map((item, i) => (
              <li key={i} className="feature-box-item">
                {item}
              </li>
            ))}
          </ul>
        )}
        
      </div>
    ))}
  </div>

</section>
<section className="collab-section">
  <div className="collab-wrapper">
    <h2 className="collab-title">Demandez Votre Consultation 100% Gratuit !</h2>
    
           <Link to="/contact#consultation">
      <button className="btn-devis">Demander une Consultation</button>
    </Link>
  </div>
</section>
    </div>
  );
};

export default ServicesPage;